import { TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { CIRCULATION_SPEED_TYPE, PROFIL } from '../../../../constants/enum';
import Radio from '@mui/material/Radio';
import FormControl from '@mui/material/FormControl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-regular-svg-icons/faQuestionCircle';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons/faTimesCircle';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons/faCheckCircle';
import ControlledTextField from '../../../Controlled/RequestPass/ControlledTextField';

const ConfigConvoiComponent = (props) => {
  const {
    profil,
    demandePassage,
    index,
    editable,
    config,
    caracConvoi,
    handleChange,
    demandePassageStyle,
    configBtnEditable
  } = props;
  const [currentConfig, setCurrentConfig] = useState(config);
  const configurations = caracConvoi.configurations;

  const configCss = {
    row: {
      width: '100%',
      height: '100px',
      display: 'flex',
      alignItems: 'center',
    },
    icon: {
      width: '25px',
      height: '25px',
      marginLeft: '5px',
      color: '#646E78',
    },
  };

  useEffect(() => {
    let configurationsToUpdate = [...configurations];
    configurationsToUpdate[index] = currentConfig;
    handleChange('configurations', configurationsToUpdate)
  }, [currentConfig]);

  const handleValidationChange = (value) => {
    setCurrentConfig({ ...currentConfig, validation: value });
  };

  const handleConfigChanges = (name, value) => {
    setCurrentConfig({...currentConfig, [name]: value});
  };

  return <div style={configCss.row}>
    <FormControl
      style={{ margin: '20px', width: 'auto', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
      <FormLabel>Configuration n°</FormLabel>
      <ControlledTextField
        type='text'
        name='index'
        value={currentConfig.index || ''}
        style={{ ...demandePassageStyle.textField, width: '50px' }}
        autoComplete='off'
        onChange={(e) => handleConfigChanges(e.target.name, e.target.value)}
        inputProps={{ maxLength: 2 }}
        disabled={true}
      pattern={'^[0-9]*$'}
      />
    </FormControl>
    <ControlledTextField
      label="Charge maxi à l'essieu (kg)"
      type='text'
      name='chargeMaxiEssieu'
      value={config.chargeMaxiEssieu || ''}
      style={{ ...demandePassageStyle.textField, width: 'auto', flexGrow: 1 }}
      autoComplete='off'
      onChange={(e) => handleConfigChanges(e.target.name, e.target.value)}
      inputProps={{ maxLength: 6 }}
      disabled={editable}
      pattern={'^[0-9]*$'}
    />
    <ControlledTextField
      label='Distance mini inter essieu (mm)'
      type='text'
      name='distanceMiniInterEssieu'
      value={config.distanceMiniInterEssieu || ''}
      style={{ ...demandePassageStyle.textField, width: 'auto', flexGrow: 1 }}
      autoComplete='off'
      onChange={(e) => handleConfigChanges(e.target.name, e.target.value)}
      inputProps={{ maxLength: 6 }}
      disabled={editable}
      pattern={'^[0-9]*$'}
    />
    {(profil.profil === PROFIL.ADMINISTRATEUR || profil.profil === PROFIL.GESTIONNAIRE || profil.profil === PROFIL.INTERVENANT) && demandePassage.id !== 0 &&
      <FormControl
        style={{ width: 'auto' }}>
        <RadioGroup row name='validation' value={currentConfig.validation}
                    onChange={(e) => handleValidationChange(e.target.value)}>
          <FormControlLabel value={0}
                            control={<Radio
                              icon={<FontAwesomeIcon
                                style={configCss.icon}
                                icon={faCheckCircle}
                              />}
                              checkedIcon={<FontAwesomeIcon
                                style={{ ...configCss.icon, color: '#9DBF42' }}
                                icon={faCheckCircle}
                              />}
                            />}
                            label={null}
                            disabled={configBtnEditable} />

          <FormControlLabel value={1}
                            control={<Radio
                              icon={<FontAwesomeIcon
                                style={configCss.icon}
                                icon={faQuestionCircle}
                              />}
                              checkedIcon={<FontAwesomeIcon
                                style={{ ...configCss.icon, color: '#FD6236' }}
                                icon={faQuestionCircle}
                              />}
                            />}
                            label={null}
                            disabled={configBtnEditable} />

          <FormControlLabel value={2}
                            control={<Radio
                              icon={<FontAwesomeIcon
                                style={configCss.icon}
                                icon={faTimesCircle}
                              />}
                              checkedIcon={<FontAwesomeIcon
                                style={{ ...configCss.icon, color: '#E85454' }}
                                icon={faTimesCircle}
                              />}
                            />}
                            label={null}
                            disabled={configBtnEditable}
          />
        </RadioGroup>
      </FormControl>}
  </div>;
};

export default ConfigConvoiComponent;